import React, { Suspense, ReactNode } from 'react';
import { lazy } from 'react';
import BaseLayout from '@src/layouts/BaseLayout';
const Error = lazy(() => import('@pages/404'))
const Index = lazy(() => import('@pages/Index'))
const ContactUs = lazy(() => import('@pages/Contact'))
const AboutUs = lazy(() => import('@pages/About'))

const LazyComponent = (element: ReactNode): ReactNode => {
  return (
    <Suspense fallback={<div></div>}>
      { element }
    </Suspense>
  )
}

const routeList = [
  {
    path: '/',
    meta: {
      auth: true,
      menu: true,
    },
    element: LazyComponent(<BaseLayout />),
    children: [
      {
        path: '/',
        meta: {
          auth: true,
          menu: true,
          label: '首页',
        },
        element: <Index />
      },
      {
        path: '/contactus',
        meta: {
          auth: true,
          menu: true,
          label: 'Contact Us',
        },
        element: <ContactUs />
      },
      {
        path: '/aboutus',
        meta: {
          auth: true,
          menu: true,
          label: 'About Us',
        },
        element: <AboutUs />
      },
    ]
  },
  {
    path: '/*',
    element: LazyComponent(<Error />)
  }
]

export default routeList;